import React from 'react';
import { Input, Label } from 'reactstrap';

class Cities extends React.Component {

    getCities = () => {
        const options = [<option key={0} value={''} disabled>Select a City</option>];

        this.props.cities && this.props.cities.forEach((city, index) => {
            options.push(<option key={index+1} value={city.cityId}>{city.name}</option>);
        });

        return options;
    }

    handleOnChange = (e) => this.props.onChange(e.target.value);

    render() {
        return (
            <React.Fragment>
                <Label>City:</Label>
                <Input name='city' type='select' id='selectCity' onChange={this.handleOnChange} value={this.props.value || ''}>
                    {this.getCities()}
                </Input>
            </React.Fragment>
        );
    }
}

export default Cities;